import moment from 'moment';

export const pagesRouter = (locationRouter: string) => {
    const pagesData: any = {
        '/withdrawal': 'Transactions',
        '/monthly-reports': 'Monthly Reports',
        '/completed-transactions': 'Completed Transactions',
        '/pending-transactions': 'Pending Transactions',
        '/dashboard': 'Dashboard',
        '/setting': 'Settings',
        '/developers': 'Developers',
        '/compliance': 'Compliance',
    }

    return pagesData[locationRouter]
}

export const formatDecimal = (amount: number | string) => {
    return amount?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const formatDate = (date: string) => {
    return moment(date).format('DD/MM/YYYY HH:mm A');
}

export const formatDate_hours = (date: string) => {
    return moment(date).format('YYYYMMDDHHmmA');
}

export const formatDate_ddMMYYYY = (date: string) => {
    return moment(date).format('DD/MM/YYYY');
}
export const formatDate_YYYYMMDD = (date: string) => {
    return moment(date).format('YYYY-MM-DD');
}

export const formatDate_ddMMYY = (date: string) => {
    return moment(date).format('DD/MM/YY');
}
export const formatDateStr = (date: string) => {
    return moment(date).format('MMM Do YYYY');
}

export const stringMin = (str: string) => {
    return str?.charAt(0).toUpperCase() + str?.slice(1).toLowerCase();
}

export const classNames = (...classes: string[]) => {
    return classes.filter(Boolean).join(' ');
}

export const deleteSpace = (str: string) => {
    return str?.replace(/\s+/g, '');
}

export const format_id = (id: string) => {
    return `${id?.substring(0, 8)}....${id?.substring(id.length - 8)}`;
}

export const format_idByDigit = (id: string, dig: number) => {
    return `${id?.slice(dig)}`;
}

export const format_text = (txt: string) => {
    return txt?.replace(/[^a-zA-Z0-9]/g, "");
}

export const format_textdelete = (txt: string) => {
    return txt?.replace(/[()]/g, "");
}

export const ValidAccessToken = () => {
    const token: string | null = localStorage.getItem('token')
    if (!token) {
        window.location.href = '/';
    }
}

export const currencyFormatter = ({ currency, value }: { currency: string, value: number }) => {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        minimumFractionDigits: 2,
        currency
    })
    return formatter.format(value)
}

export const downloadFile = (data: any, dateFile: string, typeOperation: string) => {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${typeOperation + '_' + formatDate_hours(dateFile)}.csv`);
    document.body.appendChild(link);
    link.click();
}

export const validKycStatus = (statuskyc: boolean | null | undefined): string =>
statuskyc === undefined ? 'null' : String(statuskyc)